export const openNewLocation = (href: string, isOpenInNewTab = false) => {
    const newWindow = window.open(href, isOpenInNewTab ? '_blank' : '_self', 'noopener,noreferrer');
    if (newWindow)  {
        newWindow.opener = null;
    }
};
